"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            categories: null,
            targetedId: false,
            showForm: false,
            dialog: false
        };
    },
    onMount: function () {
        this.fetchCategories();
    },
    onShowForm: function (status) {
        this.state.showForm = status;
    },
    fetchCategories: async function () {
        try {
            const {error, message, results} = await Request('/category/list');
            if (error)
                throw new Error(message);
            this.state.categories = results;
        } catch (error) {
            console.log('Error Fetching Categories', error);
            this.state.categories = null;
        }
    },
    onSubmitCategory: async function (action, form, callback) {
        if (action == 'add')
            try {
                let url = '/category/create';
                if (this.state.targetedId)
                    url += '?subto=' + this.state.targetedId;
                const {error, message} = await Request(url, 'POST', form);
                if (error)
                    return console.log('Error saving category: ', message);
                this.fetchCategories();
                this.state.targetedId = false;
                typeof callback == 'function' && callback();
            } catch (error) {
                console.log('[CATEGORY]: Error Saving Category: ', error);
            }
        else if (action == 'edit')
            try {
                const {error, message} = await Request(`/category/update/${ this.state.targetedId }`, 'PUT', form);
                if (error)
                    return console.log('Error Updating category: ', message);
                this.fetchCategories();
                this.state.targetedId = false;
                typeof callback == 'function' && callback();
            } catch (error) {
                console.log('[CATEGORY]: Error Updating Category: ', error);
            }
    },
    onAdd: function (id) {
        this.setState({
            targetedId: id,
            showForm: true
        });
    },
    onEdit: function (category) {
        this.setState({
            targetedId: category.categoryId,
            showForm: category
        });
    },
    onDelete: function (id) {
        this.onDialog({
            type: 'warning',
            message: 'Are you sure about deleting this category?',
            actions: {
                yes: {
                    fn: async function () {
                        try {
                            const {error, message} = await Request(`/category/delete/${ id }`, 'DELETE');
                            if (error)
                                return console.log('Error Deleting category: ', message);
                            this.fetchCategories();
                        } catch (error) {
                            console.log('Error Deleting Course: ', error);
                        }
                    }.bind(this)
                }
            }
        });
    },
    onDialog: function (params) {
        this.state.dialog = params;
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Categories/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Image_template = require("../../../components/Image/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Image_tag = marko_loadTag(Image_template),
    Bx_template = require("../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    marko_forIn = require("marko/dist/runtime/helpers/for-in"),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    marko_dynamicTag = require("marko/dist/runtime/helpers/dynamic-tag"),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    LoadingPage_template = require("../../components/LoadingPage.marko"),
    LoadingPage_tag = marko_loadTag(LoadingPage_template),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    AddEdit_template = require("./components/AddEdit.marko"),
    AddEdit_tag = marko_loadTag(AddEdit_template),
    DialogModal_template = require("../../../components/DialogModal/index.marko"),
    DialogModal_tag = marko_loadTag(DialogModal_template),
    Wrapper_Admin_template = require("../../components/Wrapper-Admin.marko"),
    Wrapper_Admin_tag = marko_loadTag(Wrapper_Admin_template),
    marko_attrs0 = {
        "class": "position-relative zindex-1"
      },
    marko_attrs1 = {
        "class": "d-inline-block px-1 font-medium-2"
      },
    marko_attrs2 = {
        "class": "d-inline-flex align-items-center justify-content-center pl-2"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("c314d2"),
    marko_node0 = marko_createElement("div", {
        "class": "position-absolute border-left border-bottom border-3",
        style: "width:70px;height:30px;margin-left:-63px;border-radius: 0 0 0 15px"
      }, "12", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "d-flex align-items-center",
        style: "height:50vh"
      },
    marko_attrs4 = {
        "class": "w-100 text-center"
      },
    marko_node1 = marko_createElement("br", null, "18", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node2 = marko_createElement("br", null, "19", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs5 = {
        "class": "btn btn-primary btn-lg"
      },
    marko_attrs6 = {
        "class": "px-2"
      },
    marko_node3 = marko_createElement("br", null, "23", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node4 = marko_createElement("br", null, "24", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs7 = {
        "class": "btn btn-primary btn-lg"
      };

function render(input, out, __component, component, state) {
  var data = input;

  function macro_Mapper(out, { firstGap, categoryId, name, description, poster, subs }) {
    out.be("div", marko_attrs0, "0", component);

    out.be("div", {
        "class": "d-flex align-items-center",
        title: Locale(description)
      }, "1", component);

    Image_tag({
        alt: "Image",
        src: poster,
        class: "border rounded",
        style: "width:60px;height:60px",
        icon: "bx bx-category"
      }, out, __component, "2");

    out.e("div", marko_attrs1, "3", component, 1)
      .t(name, component);

    out.be("div", marko_attrs2, "4", component);

    out.be("span", {
        "class": "px-50 cursor-pointer",
        title: Locale("Add Sub-Category")
      }, "5", component, null, 0, {
        onclick: __component.d("click", "onAdd", false, [
            categoryId
          ])
      });

    Bx_tag({
        type: "plus",
        class: "font-medium-5"
      }, out, __component, "6");

    out.ee();

    out.be("span", {
        "class": "px-50 cursor-pointer",
        title: Locale("Edit")
      }, "7", component, null, 0, {
        onclick: __component.d("click", "onEdit", false, [
            {
                categoryId: categoryId,
                name: name,
                description: description,
                poster: poster,
                subs: subs
              }
          ])
      });

    Bx_tag({
        type: "pencil",
        class: "font-medium-5"
      }, out, __component, "8");

    out.ee();

    out.be("span", {
        "class": "px-50 cursor-pointer",
        title: Locale("Delete")
      }, "9", component, null, 0, {
        onclick: __component.d("click", "onDelete", false, [
            categoryId
          ])
      });

    Bx_tag({
        type: "trash",
        class: "font-medium-5"
      }, out, __component, "10");

    out.ee();

    out.ee();

    out.ee();

    const len = typeof subs == 'object' && Object.keys( subs ).length

    let counter = 0

    out.be("div", {
        "class": marko_classValue((counter < len) || firstGap ? "border-left border-3" : ""),
        style: "padding:5px 0 5px 60px;margin-left:28px"
      }, "11", component, null, 1);

    if (len) {
      out.n(marko_node0, component);

      var $for$0 = 0;

      marko_forIn(subs, function(id, category) {
        var $keyScope$0 = "[" + (($for$0++) + "]");

        marko_dynamicTag(out, macro_Mapper, function() {
          return marko_assign({
              firstGap: (len > 1) && (counter == 0)
            }, category);
        }, null, null, null, __component, "29" + $keyScope$0);

        counter++
      });
    }

    out.ee();

    out.ee();
  }

  Wrapper_Admin_tag({
      class: "position-relative w-100 h-100",
      renderBody: function(out, { themeMode }) {
        if (state.categories === null) {
          LoadingPage_tag({}, out, __component, "14");
        } else if (!state.categories.length) {
          out.be("div", marko_attrs3, "15", component);

          out.be("div", marko_attrs4, "16", component);

          Image_tag({
              alt: "Image",
              src: "/images/illustration/folder_tree.png",
              class: "img-fluid",
              style: "width:300px;opacity:0.5"
            }, out, __component, "17");

          out.n(marko_node1, component);

          out.n(marko_node2, component);

          out.be("button", marko_attrs5, "20", component, null, 0, {
              onclick: __component.d("click", "onShowForm", false, [
                  true
                ])
            });

          Locale_tag({
              text: "Add Category"
            }, out, __component, "21");

          out.ee();

          out.ee();

          out.ee();
        } else {
          out.be("div", marko_attrs6, "22", component);

          var $for$1 = 0;

          marko_forOf(state.categories, function(category, index) {
            var $keyScope$1 = "[" + (($for$1++) + "]");

            marko_dynamicTag(out, macro_Mapper, function() {
              return marko_assign({
                  firstGap: (state.categories.length > 1) && (index == 0)
                }, category);
            }, null, null, null, __component, "30" + $keyScope$1);
          });

          out.n(marko_node3, component);

          out.n(marko_node4, component);

          out.be("button", marko_attrs7, "25", component, null, 0, {
              onclick: __component.d("click", "onShowForm", false, [
                  true
                ])
            });

          Locale_tag({
              text: "Add Category"
            }, out, __component, "26");

          out.ee();

          out.ee();
        }

        if (state.showForm) {
          AddEdit_tag({
              themeMode: themeMode,
              edit: (typeof state.showForm) == "object" ? state.showForm : false
            }, out, __component, "27", [
            [
              "submit",
              "onSubmitCategory",
              false
            ],
            [
              "dismiss",
              "onShowForm",
              false,
              [
                  false
                ]
            ]
          ]);
        }

        if (state.dialog) {
          const { message, actions, ...rest } = state.dialog

          DialogModal_tag(marko_assign({
              message: message,
              actions: actions
            }, rest), out, __component, "28", [
            [
              "dismiss",
              "onDialog",
              false,
              [
                  null
                ]
            ]
          ]);
        }
      }
    }, out, __component, "13");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
